export const LANGUAGE_TYPE = {
    FR: 'fr',
    EN: 'en',
};

export const LANGUAGE_LBL = [
    { value: LANGUAGE_TYPE.FR, label: 'Français' },
    { value: LANGUAGE_TYPE.EN, label: 'Anglais' },
];